import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { setPaginationParams } from "../../../helpers";
export class LCDQueryClient {
  constructor({
    requestClient
  }) {
    _defineProperty(this, "req", void 0);

    this.req = requestClient;
    this.sales = this.sales.bind(this);
    this.sale = this.sale.bind(this);
    this.userPosition = this.userPosition.bind(this);
  }
  /* Returns list of Sales ordered by the creation time */


  async sales(params = {
    pagination: undefined
  }) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      setPaginationParams(options, params.pagination);
    }

    const endpoint = `cosmos/streamswap/v1/sales`;
    return await this.req.get(endpoint, options);
  }
  /* Returns the specific Sale object */


  async sale(params) {
    const endpoint = `cosmos/streamswap/v1/sales/${params.saleId}`;
    return await this.req.get(endpoint);
  }
  /* UserPosition */


  async userPosition(params) {
    const endpoint = `cosmos/streamswap/v1/sales/${params.saleId}/${params.user}`;
    return await this.req.get(endpoint);
  }

}